import { handleError } from '@slr/shared-library';
import { API_USER_SERVICE_URL } from 'configs';
import { useCallback } from 'react';
import useGetApiConfig from '../useGetApiConfig';
import { AccountDeletionEligibility } from './accountDeletionEligibility.types';

export const useAccountDeletionEligibilityApi = () => {
  const apiConfig = useGetApiConfig(API_USER_SERVICE_URL, false);

  const getAccountDeletionEligibility = useCallback(
    async (userId: string) => {
      const accessToken =
        typeof apiConfig.accessToken === 'function'
          ? await apiConfig.accessToken()
          : apiConfig.accessToken;

      const response = await fetch(
        `${apiConfig.basePath}/users/${encodeURIComponent(userId)}/data-privacy/deletion-eligibility`,
        {
          headers: {
            Accept: 'application/json',
            ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
          }
        }
      );

      if (!response.ok) {
        let message = response.statusText;
        try {
          const errorBody = await response.json();
          message = errorBody?.message || errorBody?.detail || message;
        } catch {
          // ignore parse errors
        }
        const error = new Error(message) as Error & { status?: number };
        error.status = response.status;
        throw error;
      }

      return (await response.json()) as AccountDeletionEligibility;
    },
    [apiConfig]
  );

  return {
    getAccountDeletionEligibility: (userId: string) =>
      getAccountDeletionEligibility(userId).catch(handleError)
  };
};
